import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IUpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  displayName?: string;
  phoneNumber?: string;
  /** Business: the signer's roles in the company (BC_Identity CustomerCompanyRoles). Omit to keep. */
  rolesInCompany?: string[];
}

export interface IChangePasswordRequest {
  newPassword: string;
  forceChangeOnNextSignIn?: boolean;
}

export interface ICustomerProfile {
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  email: string | null;
  companyName: string | null;
  clientType: number | null;
  /** Business: "Director", "Ultimate beneficial owner", … as chosen at sign-up. Empty when unknown. */
  rolesInCompany?: string[];
}

@Injectable({ providedIn: 'root' })
export class AccountSettingsService {
  private readonly httpClient = inject(HttpClient);
  private readonly url = environment.apiConfig.IdentityAPI.endpoint;

  /** Loads the calling B2C customer's saved profile (name / phone / email). */
  getProfile(): Observable<ICustomerProfile> {
    return this.httpClient.get<ICustomerProfile>(`${this.url}/customer/account/profile`);
  }

  /**
   * Updates the directory profile of the calling B2C customer via Microsoft Graph.
   * Backend: BC_Identity CustomerAccountController.UpdateProfile.
   */
  updateProfile(request: IUpdateProfileRequest): Observable<void> {
    return this.httpClient.put<void>(`${this.url}/customer/account/profile`, request);
  }

  /**
   * Resets the calling B2C customer's password via Microsoft Graph.
   * Note: Graph cannot validate the existing password — if "current password"
   * verification is a hard requirement, route through the B2C password-reset flow instead.
   */
  changePassword(request: IChangePasswordRequest): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/customer/account/change-password`, request);
  }
}
